import { Routes } from '@angular/router';

import { environment } from '@environments';
import { adminGuard } from '@shared/guards/admin.guard';

import { ReportType } from './enums/ReportType.enum';
import {
  CampaignsComponent,
  CampaignsFormComponent,
  CampaignsShowComponent,
  ChannelsComponent,
  ChannelsFormComponent,
  ClientsComponent,
  ClientsFormComponent,
  GeneralReportComponent,
  HomeComponent,
  PermissionsComponent,
  PermissionsFormComponent,
  PrivacyComponent,
  ProfileComponent,
  PropertiesComponent,
  PropertiesFormComponent,
  RolesComponent,
  RolesFormComponent,
  SegmentFormComponent,
  SegmentsComponent,
  TermsComponent,
  UsersComponent,
  UsersFormComponent,
} from './pages';
import { CampaignWrapperComponent } from './campaigns/components/campaign-wrapper/campaign-wrapper.component';

export const adminRoutes: Routes = [
  // * CRUD ROUTES
  {
    path: 'campaigns',
    title: `Campaigns - ${environment.title}`,
    canActivate: [adminGuard],
    data: { requiredRoles: ['admin.campaigns.index'], breadcrumb: 'Campaigns' },
    children: [
      {
        path: '',
        component: CampaignsComponent,
      },
      {
        path: 'client/:clientId',
        component: CampaignsComponent,
      },
      {
        path: 'create',
        component: CampaignsFormComponent,
      },
      {
        path: ':id',
        component: CampaignWrapperComponent,
        children: [
          {
            path: '',
            component: CampaignsShowComponent,
          },
          {
            path: 'edit',
            component: CampaignsFormComponent,
          },
          // ! REPORT
          {
            path: 'general-report',
            component: GeneralReportComponent,
            data: {
              type: ReportType.general,
            },
          },
          // ! REPORT
          {
            path: 'client/:clientId',
            component: CampaignsShowComponent,
          },
          // ! REPORT
          {
            path: 'client/:clientId/general-report',
            component: GeneralReportComponent,
            data: {
              type: ReportType.general,
            },
          },
          // ! REPORT
          {
            path: 'client/:clientId/period/:periodId/property/:propertyId',
            component: CampaignsShowComponent,
          },
          // ! REPORT
          {
            path: 'client/:clientId/period/:periodId/property/:propertyId/general-report',
            component: GeneralReportComponent,
            data: {
              type: ReportType.quarter,
            },
          },
          // ! REPORT
          {
            path: 'period/:periodId/property/:propertyId',
            component: CampaignsShowComponent,
          },
          // ! REPORT
          {
            path: 'period/:periodId/property/:propertyId/general-report',
            component: GeneralReportComponent,
            data: {
              type: ReportType.quarter,
            },
          },
          // ! REPORT
          // * PERIODS
          {
            path: 'period/:periodId/property/:propertyId/client/:clientId/:type/:typeId',
            component: SegmentsComponent,
          },
          // ! REPORT
          {
            path: 'period/:periodId/property/:propertyId/client/:clientId/:type/:typeId/general-report',
            component: GeneralReportComponent,
            data: {
              type: ReportType.month,
            },
          },
          // ! REPORT
          {
            path: 'period/:periodId/property/:propertyId/:type/:typeId',
            component: SegmentsComponent,
          },
          // ! REPORT
          {
            path: 'period/:periodId/property/:propertyId/:type/:typeId/general-report',
            component: GeneralReportComponent,
            data: {
              type: ReportType.month,
            },
          },
          {
            path: 'period/:periodId/property/:propertyId/:type/:typeId/segment/:segmentId',
            component: SegmentFormComponent,
          },
          {
            path: 'period/:periodId/property/:propertyId/client/:clientId/:type/:typeId/segment/:segmentId',
            component: SegmentFormComponent,
          },
          // * PERIODS
        ],
      },
    ],
  },
  {
    path: 'channels',
    title: `Channels - ${environment.title}`,
    canActivate: [adminGuard],
    data: { requiredRoles: ['admin.channels.index'] },
    children: [
      {
        path: '',
        component: ChannelsComponent,
      },
      {
        path: 'create',
        component: ChannelsFormComponent,
      },
      {
        path: 'edit/:id',
        component: ChannelsFormComponent,
      },
      {
        path: ':id',
        component: ChannelsFormComponent,
        data: { readonly: true },
      },
    ],
  },
  {
    path: 'clients',
    title: `Clients - ${environment.title}`,
    canActivate: [adminGuard],
    data: { requiredRoles: ['admin.clients.index'] },
    children: [
      {
        path: '',
        component: ClientsComponent,
      },
      {
        path: 'create',
        component: ClientsFormComponent,
      },
      {
        path: ':id/edit',
        component: ClientsFormComponent,
      },
      {
        path: ':id',
        component: ClientsFormComponent,
        data: { readonly: true },
      },
    ],
  },
  {
    path: 'permissions',
    title: `Permissions - ${environment.title}`,
    canActivate: [adminGuard],
    data: { requiredRoles: ['admin.permissions.index'] },
    children: [
      {
        path: '',
        component: PermissionsComponent,
      },
      {
        path: 'create',
        component: PermissionsFormComponent,
      },
      {
        path: 'edit/:id',
        component: PermissionsFormComponent,
      },
      {
        path: ':id',
        component: PermissionsFormComponent,
        data: { readonly: true },
      },
    ],
  },
  {
    path: 'properties',
    title: `Properties - ${environment.title}`,
    canActivate: [adminGuard],
    data: { requiredRoles: ['admin.properties.index'] },
    children: [
      {
        path: '',
        component: PropertiesComponent,
      },
      {
        path: 'create',
        component: PropertiesFormComponent,
      },
      {
        path: 'edit/:id',
        component: PropertiesFormComponent,
      },
      {
        path: ':id',
        component: PropertiesFormComponent,
        data: { readonly: true },
      },
    ],
  },
  {
    path: 'roles',
    title: `Roles - ${environment.title}`,
    canActivate: [adminGuard],
    data: { requiredRoles: ['admin.roles.index'] },
    children: [
      {
        path: '',
        component: RolesComponent,
      },
      {
        path: 'create',
        component: RolesFormComponent,
      },
      {
        path: 'edit/:id',
        component: RolesFormComponent,
      },
      {
        path: ':id',
        component: RolesFormComponent,
        data: { readonly: true },
      },
    ],
  },
  {
    path: 'users',
    title: `Users - ${environment.title}`,
    canActivate: [adminGuard],
    data: { requiredRoles: ['admin.users.index'] },
    children: [
      {
        path: '',
        component: UsersComponent,
      },
      {
        path: 'create',
        component: UsersFormComponent,
      },
      {
        path: 'edit/:id',
        component: UsersFormComponent,
      },
      {
        path: ':id',
        component: UsersFormComponent,
        data: { readonly: true },
      },
    ],
  },
  // * CRUD ROUTES
  {
    path: 'privacy',
    component: PrivacyComponent,
    title: `Privacy policy - ${environment.title}`,
  },
  {
    path: 'home',
    component: HomeComponent,
    title: `Home - ${environment.title}`,
  },
  {
    path: 'settings',
    component: ProfileComponent,
  },
  {
    path: 'terms',
    component: TermsComponent,
    title: `Terms - ${environment.title}`,
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
